/*
  Kalessie - opens the page-level back-in-stock sheet from any sold-out
  product card ([data-kal-notify]). Fills the product title + tag so the
  Shopify customer form records which product was requested.
*/
(function () {
  var sheet = document.querySelector('[data-kal-notify-sheet]');
  if (!sheet) return;
  var titleEl = sheet.querySelector('[data-kal-notify-title]');
  var tagsEl = sheet.querySelector('[data-kal-notify-tags]');
  var noteEl = sheet.querySelector('[data-kal-notify-note]');

  function open(handle, title) {
    if (titleEl) titleEl.textContent = title || '';
    if (tagsEl) tagsEl.value = 'back-in-stock, bis-' + handle;
    if (noteEl) noteEl.value = 'Back in stock request — ' + (title || handle);
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    var input = sheet.querySelector('.kal-notify__input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function close() { sheet.hidden = true; document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-kal-notify]') : null;
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-kal-notify'), trigger.getAttribute('data-kal-title'));
      return;
    }
    if (e.target.closest && e.target.closest('[data-kal-notify-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Re-open after a successful submit (Shopify reloads with ?customer_posted=true).
  try {
    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true' &&
        sheet.querySelector('.kal-notify__success')) {
      sheet.hidden = false;
    }
  } catch (e) {}
})();
